<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="notesModal" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="notesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader"> Add notes </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div v-if="loading" class="loader"></div>
          <div v-else class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <form @submit.prevent="addNewNote">
                  <label>Note:</label>
                  <div class="row mt-2">
                    <div class="col-md-12">
                      <textarea class="form-control" required rows="3" v-model="newNote"></textarea>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-12">
                      <label>Attachment:</label>
                      <input type="file" class="form-control" id="customFile" ref="file" @change="changeFile($event)">
                    </div>
                  </div>
                  <button class="btn btn-sm btn-primary float-right" type="submit">Submit</button>
                </form>
              </div>
            </div>
<!--            <section v-if="account.notes && account.notes.length > 0">-->
<!--              <hr>-->
<!--              <h5>Added Notes</h5>-->
<!--              <table class="table table-hover">-->
<!--                <thead>-->
<!--                <th>Note</th>-->
<!--                <th>Attachment</th>-->
<!--                <th>Added By</th>-->
<!--                <th>Action</th>-->
<!--                </thead>-->
<!--                <tbody>-->
<!--                <tr v-for="(row, index) of account.notes" :key="index">-->
<!--                  <td>-->
<!--                    <span v-html="row.text"></span>-->
<!--                  </td>-->
<!--                  <td>-->
<!--                    <a v-if="row.imageUrl" :href="row.imageUrl" target="_blank">Attachment</a>-->
<!--                  </td>-->
<!--                  <td>-->
<!--                    {{row.addedBy}}-->
<!--                  </td>-->
<!--                  <td>-->
<!--                    &lt;!&ndash;                        <button class="btn btn-sm btn-primary my-1 mr-1" @click="editNote(index)"><i class="fa fa-pencil"></i></button>&ndash;&gt;-->
<!--                    <button class="btn btn-sm btn-danger my-1" @click="deleteNote(index)"><i class="fa fa-trash"></i></button>-->
<!--                  </td>-->
<!--                </tr>-->
<!--                </tbody>-->
<!--              </table>-->
<!--            </section>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db, storage} from "@/firebase/init";
import swal from "sweetalert2";

export default {
name: "domain-notes",
  data () {
    return {
      newNote: null,
      domainName: null,
      account: {},
      editIndex: null,
      file: null,
      event: null,
      url: null,
      loading: false,
      uid: ''
    }
  },
  props: {
    docID: {
      required: true,
          type: String
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    load (uid) {
      this.uid = uid;
      $('#notesModal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    changeFile (event) {
      this.file = event.target.files[0]
      this.url = window.URL.createObjectURL(this.file)
      this.event = event
    },
    async addNewNote () {
      try {
        let downloadURL = null
        let fileName = null;
        this.loading = true
        if (this.file) {
          if (this.file) {
            const storageRef = storage.ref();
            const timestamp = new Date().getTime().toString();
            const fileRef = storageRef.child('account-notes/' + this.file.name + timestamp );
            const uploadTask =  await fileRef.put(this.file)
            fileName = this.file.name;
            downloadURL = await uploadTask.ref.getDownloadURL()
          }
        }
        if (this.editIndex === null) {
          // this.newNote = this.newNote.replace(/\n/g, '<br>')
          const obj = {
            text: this.newNote.replace(/\n/g, '<br>'),
            addedBy: this.user.firstName + ' ' + this.user.lastName,
            imageUrl: downloadURL,
            fileName: fileName,
            createdAt: new Date().toISOString()
          }
          const ref = await db.collection('accountNotes').doc(this.docID).get();
          let notes = []
          if(ref.exists) {
            notes = ref.data().notes
          }
          notes.push(obj);
          await db.collection('accountNotes').doc(this.docID).set({notes});
        } else {

          // this.account.notes[this.editIndex].text = this.newNote
        }
        // await this.updateAccountNotes()
        if (this.file) {
          if (this.event) {
            this.event.target.value = ''
          }
          this.file = null
          this.url = null
        }
        this.newNote = null;
        await this.$parent.getAllAccountNotes()
        this.loading = false
      } catch (e) {
        console.log(e.toString())
        swal({
          title: 'Error',
          text: 'Something went wrong while adding notes! ' + e.toString(),
          type: 'error'
        })
      } finally {
        this.loading = false;
        $('#notesModal').modal('hide');
      }
    },
    async deleteNote (index) {
      this.loading = true
      this.account.notes.splice(index, 1)
      await this.updateAccountNotes()
      this.loading = false
    },
    editNote (index) {
      this.newNote = this.account.notes[index].text
      this.editIndex = index
    },
    async updateAccountNotes () {
      // update in db
      console.log('docId', this.docID, this.account)
      const accRef = await db
          .collection("hostingAccounts")
          .doc(this.docID).get();
      const { accounts } = accRef.data();
      const acc = accounts[this.account.planIndex];
      if (this.account.addonIndex === null) {
        acc.primary.notes = this.account.notes
      } else {
        acc.addon[this.account.addonIndex].notes = this.account.notes
      }
      await db
          .collection("hostingAccounts")
          .doc(this.docID).update({
            accounts,
            updatedAt: new Date().toISOString()
          });
      this.addLog({
        message: 'Notes has been updated for this account',
        level: 'info'
      })
      swal('SUCCESS!', 'Notes has been updated for this account', "success");
      this.newNote = null
      this.editIndex = null
    },
  }
}
</script>

<style scoped>

</style>
